import { createFeatureSelector } from "@ngrx/store";
import { GlobalFeatureState } from "../reducers";
import { globalFeatureKey } from "../feature-key";

export const selectGlobalFeatureState = createFeatureSelector<GlobalFeatureState>(globalFeatureKey);
